module.exports = __webpack_public_path__ + "static/media/herramienta-naranja.fdb05223.svg";